import { render, staticRenderFns } from "./Kviewchan.vue?vue&type=template&id=dbd5b7c4&scoped=true"
import script from "./Kviewchan.vue?vue&type=script&lang=js"
export * from "./Kviewchan.vue?vue&type=script&lang=js"
import style0 from "./Kviewchan.vue?vue&type=style&index=0&id=dbd5b7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd5b7c4",
  null
  
)

export default component.exports